export const TENANT_CONTACT_EMAIL = 'hub.inovacao@guaxupe.mg.gov.br'
